<template>
    <div id="hello">

        <div id="render-wrapper">
            <Render v-bind:isDay="isDay"></Render>
        </div>





<div id="content" class="format">

        <div class="container is-fluid" style="padding-top: 50px;" >

            <div class="columns">
                <div class="column is-full">

                        <h1>RODO – informacja obowiązkowa dotycząca przetwarzania danych osobowych</h1>
                    <p>Administratorem danych osobowych (dalej: &bdquo;Administrator&rdquo;) jest Helvetia City sp. z o.o. z siedzibą w Lublinie, adres:  ul. Jutrzenki 3/70, 
20-538 Lublin, wpisana do Rejestru Przedsiębiorc&oacute;w Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Lublin-Wsch&oacute;d z siedzibą w Świdniku VI Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS 0000890406, posiadająca NIP: 712-337-93-19, REGON: 382275650.</p>
                    <p>Administrator danych osobowych wdraża wszystkie wytyczne wynikające z zapis&oacute;w Rozporządzenia Parlamentu Europejskiego i Rady (EU) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (og&oacute;lne rozporządzenie o ochronie danych osobowych).</p>
                    <p>We wszystkich sprawach dotyczących przetwarzania przez Administratora danych osobowych oraz korzystania z praw związanych z przetwarzaniem danych osobowych prosimy kontaktować się na adres e-mail: sprzedaz@kaczencova.pl, lub pisemnie na adres Administratora z dopiskiem &bdquo;Dane osobowe&rdquo;.</p>
                    <p>Państwa dane osobowe przetwarzane są w celu:</p>
                    <ul>
                        <li>
                            Podjęcia niezbędnych działań przed zawarciem umowy, zawarcia i wykonania umowy (Art. 6 ust. 1 lit. b oraz f RODO).
                        </li>
                        <li>
                           Dla cel&oacute;w marketingowych Administratora (Art. 6 ust. 1 lit. b oraz f RODO).
                        </li>
                        <li>
                            W celu dochodzenia roszczeń związanych z zawartą z Panią/Panem umową lub świadczonymi usługami (Art. 6 ust. 1 lit. b oraz f RODO).
                        </li>
                    </ul>
                    <p>Państwa dane osobowe będą przechowywane do momentu przedawnienia roszczeń z tytułu umowy lub do momentu wygaśnięcia obowiązku przechowywania danych wynikającego z przepis&oacute;w prawa, w szczeg&oacute;lności obowiązku przechowywania dokument&oacute;w księgowych dotyczących umowy. Wszelkie dane przetwarzane na potrzeby rachunkowości oraz ze względ&oacute;w podatkowych przetwarzamy przez 5 lat liczonych od końca roku kalendarzowego, w kt&oacute;rym powstał obowiązek podatkowy. Po upływie wyżej wymienionych okres&oacute;w dane są usuwane.</p>
                    <p>Ponadto dane osobowe nie będą udostępniane podmiotom innym, niż upoważnione na podstawie przepis&oacute;w prawa.</p>
                    <p>Zebrane dane osobowe nie będą przekazywane do odbiorc&oacute;w znajdujących się w państwach poza Europejskim Obszarem Gospodarczym.</p>
                    <p>Przysługuje Państwu prawo dostępu do swoich danych osobowych. Mogą Państwo uzyskać kopię danych osobowych oraz sprawdzić, czy przetwarzamy je zgodnie z prawem. Mogą też Państwo sprostować przechowywane przez nas swoje dane osobowe oraz uzupełnić wszelkie niekompletne dane lub sprostować niepoprawne informacje.</p>
                    <p><strong>Ponadto informujemy, że podanie danych osobowych w związku z zawieraną umową jest dobrowolne, ale konieczne do zawarcia i wykonywania umowy, bez podania danych osobowych nie jest możliwe zawarcie umowy.</strong></p>
                </div>
            </div>

        </div>


        <hr>

        <div style="padding-bottom: 4em;">

        </div>
</div>
    </div>
</template>

<script>
    import Render from "../components/Render";

    export default {
        name: 'Privacy',
        data() {
            return {
                isDay: false,
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            }
        },

        components: {
            Render: Render
        }
    }
</script>

